import React from 'react';
import TextInput from './TextInput';

export default function TextAreaWithLabel(props) {
  return (
    <TextInput {...props} withLabel textarea />
  );
}
